import { Link } from 'deepstash-ui';
import React from 'react';
import NextLink from 'src/components/navigation/NextLink';
import { Source } from 'types/models';
import { onLinkClick, slugify } from 'utils/global';
import useLocation from 'hooks/useLocation';
import useAuth from 'src/providers/hooks/useAuth';
import { useRouter } from 'next/router';

export const getLink = (source: Source): string =>
  `/article/${source.id}/${slugify(source.title)}`;

const getCollectionSourceLink = ({
  source,
  collectionId,
}: {
  source: Source;
  collectionId: string;
}): string =>
  `/article/${source.id}/${slugify(source.title)}?collection=${collectionId}`;

interface OwnProps {
  source: Source;
  /**
   * The Link component isn't rendered on the article page or source page
   * Use this to override that
   */
  withLink?: boolean;
  /**
   * Wether to have a static sourceCard that is not interactable
   */
  isNotInteractable?: boolean;
}

export const InfoLinkWrapper: React.FC<OwnProps> = ({
  children,
  source,
  withLink,
  isNotInteractable,
}): JSX.Element => {
  const location = useLocation();
  const router = useRouter();
  const { isLoggedIn } = useAuth();

  // if we are on the article or add-source pages, don't wrap in a NextLink
  //If withLink is true, it would override the regex match
  if ((location.match(/article|studio/g) && !withLink) || isNotInteractable) {
    return <>{children}</>;
  }

  let link = getLink(source);

  if (location.match(/collection/) && isLoggedIn) {
    link = getCollectionSourceLink({
      source,
      collectionId: router.asPath.split('/')?.[2] ?? '0',
    });
  }

  return (
    <NextLink href={link}>
      <Link
        href={link}
        onClick={onLinkClick}
        _focus={undefined}
        _hover={undefined}
        _active={undefined}
        isExternal={false}
        width="100%"
        title={source.title}
      >
        {children}
      </Link>
    </NextLink>
  );
};
